var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.530922 32.975C-0.42466 32.975 -0.318411 33.075 -0.212149 33.075H-0.105848H0.000389099C0.106649 33.075 0.212898 33.075 0.31916 32.975L29.2224 16.875C29.4349 16.775 29.5412 16.575 29.5412 16.375V-15.425V-15.625C29.5412 -15.825 29.4349 -16.025 29.2224 -16.125C29.1161 -16.225 28.9036 -16.225 28.7973 -16.125L0.212925 -31.925C0.000400543 -32.025 -0.212162 -32.025 -0.424685 -31.925L-29.0091 -16.125C-29.1153 -16.225 -29.3279 -16.225 -29.4342 -16.125C-29.6467 -16.025 -29.7529 -15.825 -29.7529 -15.625V-15.425V16.375C-29.7529 16.575 -29.6467 16.775 -29.4342 16.875L-0.530922 32.975ZM28.4785 16.075L0.637934 31.475V0.774998L21.5715 -10.925L28.3723 -14.525V16.075H28.4785ZM-0.105848 -30.725L27.6285 -15.425L20.934 -11.725L-0.105848 -0.624996L-20.8269 -11.525L-27.8402 -15.425L-0.105848 -30.725ZM-28.5841 -14.425L-21.7833 -10.825L-0.849693 0.774998V31.475L-28.5841 16.075V-14.425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.a8b7fa8f4760718d2133835235c24cf0.svg";
export { ForwardRef as ReactComponent };